import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=ed9e348e&scoped=true"
import script from "./Receiving.vue?vue&type=script&lang=js"
export * from "./Receiving.vue?vue&type=script&lang=js"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=ed9e348e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9e348e",
  null
  
)

export default component.exports